import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';

const tagName = 'div';

register('wm-container', (): IBuildTaskDef => {
    return {
        pre: attrs => `<${tagName} pageContainer wmContainer wmsTransclude page-container-target ${getAttrMarkup(attrs)}>`,
        post: () => `</${tagName}>`
    };
});

export default () => {};
